import { Divider as i } from "./divider.js";
export {
  i as Divider
};
